export default function (map, zoom) {
  if (!map) return;
  if (map.getZoom() > zoom) map.setZoom(zoom);
}
